import router from '@/router';
import { routerBeforeEach } from 'ant-design-vue-admin-x';

router.beforeEach(routerBeforeEach);
